import { memo } from "react";
import { Col, Container, FormControl, Row } from "react-bootstrap";
import { BzButton, BzChip, BzHeading } from "../../../components";
import { handleModal } from "../../../redux/actions/modals";
import { useDispatch } from "react-redux";



const ExploreAllFunds = ({ mutualFund = [], nfo = [], hanldeOnFilter, filterToggle, setIsshowAllfundsModal, setFundToBuy, handleOnShowFundOverView }) => {

    const dispatch = useDispatch();

    //To open Order by modal
    const handleBuy = (fund) => {
        dispatch(handleModal([{ 'PLACE_MUTUAL_FUND_ORDER': true }]));
        setFundToBuy(fund);

    };

    return (
        <>
            <Container fluid className='p-0'>
                <div className='flex-column'>
                    <Row className='g-0 py-4'>
                        <Col className='d-flex justify-content-start align-items-center'>
                            {
                                !filterToggle &&
                                <div onClick={hanldeOnFilter} className='icon-20 icon-searchfilter icon-dark me-4'>&nbsp;</div>
                            }
                            <div className='icon-16 icon-backward-arrow icon-dark me-3' onClick={() => { setIsshowAllfundsModal(false); }}>&nbsp;</div>
                            <BzHeading className='font-medium font-size6 color-text pe-3'>All Funds</BzHeading>
                            <div className='font-regular font-size6 color-subtext'> {mutualFund?.length + nfo?.length} &nbsp;funds found...</div>
                        </Col>
                    </Row>
                    <Row className='g-0 pb-4'>
                        <Col md={4} className='d-flex justify-content-start align-items-center'>
                            <div className='font-regular font-size4 color-subtext'>0 filters Applied</div>
                        </Col>
                        <Col md={8} className='d-flex justify-content-end align-items-center'>
                            <div className='searchbar-wrap'>
                                <div className='searchbox'>
                                    <div className='searchicon-wrap'>
                                        <div className='icon-14 icon-search icon-grey'></div>
                                    </div>
                                    <FormControl size='sm' id='watchlist_search' type='search' className='font-regular scripname-searchtext' placeholder='Search Funds' />
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <div className='mf-explore-all-funds-scroll'>
                        <Row className='g-0 mt-4'>
                            {mutualFund.map(fund =>
                                <div key={fund.id}>
                                    <Row className='g-0 bdr-btm pb-3 mb-3'>
                                        <Col md={4} className='flex-column justify-content-start pe-5 cursor-pointer' onClick={() => handleOnShowFundOverView(fund)}>
                                            <div className='font-regular font-size4 color-text mb-1'>{fund?.fundName}</div>
                                            <div className='chips-wrap flex-wrap'>
                                                {fund?.category?.map((categoryName, index) => <BzChip key={index} className='chips primary-chip me-2 mb-2'>{categoryName}</BzChip>)}
                                            </div>
                                        </Col>
                                        <Col className='flex-column justify-content-center align-self-center'>
                                            <Row className='g-0'>
                                                <Col className='d-flex justify-content-start align-items-center'>
                                                    <div className='font-regular font-size2 color-subtext'>NAV</div>
                                                    <div className='icon-14 icon-info icon-dark ms-2'>&nbsp;</div>
                                                </Col>
                                            </Row>
                                            <Row className='g-0'>
                                                <Col>
                                                    <div className='font-medium font-size4 color-text'>&#8377;{fund?.nav}</div>
                                                </Col>
                                            </Row >
                                        </Col >
                                        <Col className='flex-column justify-content-start align-self-center'>
                                            <div className='font-regular font-size2 color-subtext'>Min. Investment</div>
                                            <div className='font-medium font-size4 color-text'>&#8377;{fund?.minAmount}</div>
                                        </Col>
                                        <Col className='flex-column justify-content-start align-self-center'>
                                            <Row className='g-0'>
                                                <Col>
                                                    <div className='font-regular font-size2 color-subtext'>CAGR</div>
                                                </Col>
                                            </Row >
                                            <Row className='g-0'>
                                                <Col className='d-flex justify-content-start align-items-center'>
                                                    <div className='font-medium font-size2 color-text color-positive'>{fund?.cagr}</div>
                                                    <div className='font-regular font-size2 color-subtext ms-1'>(3Y)</div>
                                                </Col>
                                            </Row>
                                        </Col >
                                        <Col md={3} className='d-flex justify-content-end align-items-center'>
                                            <BzButton className='btn btn-outline btn-md'>SIP</BzButton>
                                            <BzButton className='btn btn-positive btn-md ms-3' onClick={() => handleBuy(fund)}>BUY</BzButton>
                                            <div className='icon-24 icon-add-circle icon-dark ms-3'>&nbsp;</div>
                                        </Col>
                                    </Row >
                                </div >)
                            }
                        </Row >
                        <Row className='g-0'>
                            {nfo.map(element =>
                                <div key={element.id}>
                                    <Row className='g-0 bdr-btm pb-3 mb-3'>
                                        <Col md={4} className='flex-column justify-content-start pe-5'>
                                            <div className='font-regular font-size4 color-text mb-1'>{element?.fundName}</div>
                                            <div className='chips-wrap flex-wrap'>
                                                {element?.category?.map((categoryName, index) => <BzChip key={index} className='chips primary-chip me-2 mb-2'>{categoryName}</BzChip>)}
                                            </div>
                                        </Col>
                                        <Col className='flex-column justify-content-center align-self-center'>
                                            <Row className='g-0'>
                                                <Col className='d-flex justify-content-start align-items-center'>
                                                    <div className='font-regular font-size2 color-subtext'>NAV</div>
                                                    <div className='icon-14 icon-info icon-dark ms-2'>&nbsp;</div>
                                                </Col>
                                            </Row>
                                            <Row className='g-0'>
                                                <Col>
                                                    <div className='font-medium font-size4 color-text'>&#8377;{element?.nav}</div>
                                                </Col>
                                            </Row >
                                        </Col >
                                        <Col className='flex-column justify-content-start align-self-center'>
                                            <div className='font-regular font-size2 color-subtext'>Min. Investment</div>
                                            <div className='font-medium font-size4 color-text'>&#8377;{element?.minAmount}</div>
                                        </Col>
                                        <Col className='flex-column justify-content-start align-self-center'>
                                            <Row className='g-0'>
                                                <Col>
                                                    <div className='font-regular font-size2 color-subtext'>CAGR</div>
                                                </Col>
                                            </Row >
                                            <Row className='g-0'>
                                                <Col className='d-flex justify-content-start align-items-center'>
                                                    <div className='font-medium font-size2 color-text color-positive'>{element?.cagr}</div>
                                                    <div className='font-regular font-size2 color-subtext ms-1'>(3Y)</div>
                                                </Col>
                                            </Row>
                                        </Col >
                                        <Col md={3} className='d-flex justify-content-end align-items-center'>
                                            <BzButton className='btn btn-outline btn-md'>SIP</BzButton>
                                            <BzButton className='btn btn-positive btn-md ms-3' onClick={() => handleBuy(element)}>BUY</BzButton>
                                            <div className='icon-24 icon-add-circle icon-dark ms-3'>&nbsp;</div>
                                        </Col>
                                    </Row >
                                </div >)
                            }
                        </Row >
                    </div >
                </div >
            </Container >
        </>
    );
};

export default memo(ExploreAllFunds);
